const initAccountNavToggle = () => {
    const navToggle = document.querySelector('.js-account-nav-toggle');
    const nav = document.querySelector('.js-account-nav');
    
    if (!navToggle || !nav) {
        return;
    }

    // Function to check if we're in mobile view (max-width: 992px)
    const isMobileView = () => {
        return window.matchMedia('(max-width: 992px)').matches;
    };

    // Toggle active class on click (only in mobile view)
    navToggle.addEventListener('click', function(e) {
        if (!isMobileView()) {
            return;
        }
        
        e.preventDefault();
        const isActive = navToggle.classList.contains('is-active');
        
        // Toggle active state
        navToggle.classList.toggle('is-active');
        nav.classList.toggle('is-open');
        
        // Update aria-expanded attribute
        const isExpanded = !isActive;
        navToggle.setAttribute('aria-expanded', isExpanded.toString());
    });

    // Remove active class when resizing to desktop view
    const handleResize = () => {
        if (!isMobileView()) {
            if (navToggle.classList.contains('is-active')) {
                navToggle.classList.remove('is-active');
                navToggle.setAttribute('aria-expanded', 'false');
            }
            if (nav.classList.contains('is-open')) {
                nav.classList.remove('is-open');
            }
        }
    };

    window.addEventListener('resize', handleResize);
    
    // Optional: Close menu when clicking outside (mobile only)
    document.addEventListener('click', function(e) {
        if (!isMobileView()) {
            return;
        }
        
        const isClickInsideNav = nav && nav.contains(e.target);
        const isClickOnToggle = navToggle.contains(e.target);
        
        if (!isClickInsideNav && !isClickOnToggle && navToggle.classList.contains('is-active')) {
            navToggle.classList.remove('is-active');
            navToggle.setAttribute('aria-expanded', 'false');
            if (nav) {
                nav.classList.remove('is-open');
            }
        }
    });
}

export { initAccountNavToggle };

